// app支持上报的最低版本
export const MINSUPPORTAPPVERSION = '050507';
